import { Modal } from "react-bootstrap"
import styles from "./ResetModal.module.scss"

const ResetModal = ({ show, setShow, onReset }: any) => {
  return (
    <Modal
      className={`${styles.addPopup} delete-qr-modal`}
      show={show}
      onHide={() => setShow(!show)}
    >
      <Modal.Header className={styles.close} closeButton></Modal.Header>
      <Modal.Body>
        <div className={styles.body}>
          <h2 className={`caption ${styles.caption}`}>
            Do you really want to discard all your changes?{" "}
          </h2>

          <div className={styles.controls}>
            <span className="btn btn-simple" onClick={onReset}>
              {"Yes"}
            </span>
            <button onClick={() => setShow(!show)} className="btn btn-dark">
              {"No"}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ResetModal
